document.addEventListener("click", function(event) {
    // Check if the clicked element is an "Add to Cart" button via data-action
    const target = event.target.closest('[data-action="add-to-cart"]');

    if (target) {
        const productId = target.getAttribute("data-product");

        if (productId) {
            // Find all elements with the same product ID and "add-to-cart" action
            const matchingButtons = document.querySelectorAll(`[data-product="${productId}"][data-action="add-to-cart"]`);

            // Update the text for all matching buttons
            matchingButtons.forEach(button => {
                button.textContent = "In cart"; // Change text to "In Cart"
                button.classList.add("dis_btn"); // Optionally, add a class to style buttons
            });

            console.log(`Updated all buttons with product ID ${productId} to "In Cart".`);
        }
    }

    // Check if the clicked element is an "Add to Cart" button with class .product-form__submit
    const submitButton = event.target.closest('.product-form__submit');

    if (submitButton) {
        const productId = submitButton.getAttribute("data-product_id");

        if (productId) {
            // Find all elements with the same product ID and "add-to-cart" action
            const matchingButtons = document.querySelectorAll(`[data-product="${productId}"][data-action="add-to-cart"]`);

            // Update the text for all matching buttons
            matchingButtons.forEach(button => {
                button.textContent = "In cart"; // Change text to "In Cart"
                button.classList.add("dis_btn"); // Optionally, add a class to style buttons
            });
            

            console.log(`Updated all buttons with product ID ${productId} to "In Cart" (via .product-form__submit).`);
        }
    }
});



document.addEventListener("click", function(event) {
    // Check if the clicked element is a "Remove" button
    const removeButton = event.target.closest(".js-remove-item");

    if (removeButton) {
        const productId = removeButton.getAttribute("data-product-id"); // Get product ID from the remove button

        if (productId) {
            // Find all "Add to Cart" buttons with the same product ID
            const matchingButtons = document.querySelectorAll(`[data-product="${productId}"][data-action="add-to-cart"]`);

            // Update the text for all matching buttons
            matchingButtons.forEach(button => {
                button.textContent = "Add to Cart"; // Change text to "Add to Cart"
                button.classList.remove("dis_btn"); // Optionally, remove the 'in-cart' class
            });

            console.log(`Updated all buttons with product ID ${productId} to "Add to Cart".`);
        }
    }
});

document.addEventListener("DOMContentLoaded", function() {

    // Get the state parameter from the URL
    const urlParams = new URLSearchParams(window.location.search);
    let stateFromURL = urlParams.get('state');

    // If no state in URL, check localStorage
    if (!stateFromURL) {
        stateFromURL = localStorage.getItem('stateSelected');
    }

    // Normalize the state value (convert to lowercase, replace spaces with hyphens)
    if (stateFromURL) {
        stateFromURL = stateFromURL.toLowerCase().trim().replace(/\s+/g, '-'); // Replace spaces with hyphens
    }

    // If a state is found, set it as the selected value in the dropdown
    if (stateFromURL) {
        const dropdown = document.getElementById('iFunction');
        if (dropdown) {
            const options = dropdown.options;
            for (let i = 0; i < options.length; i++) {
                if (options[i].value === stateFromURL) {
                    dropdown.selectedIndex = i;
                    break;
                }
            }
        }
    }

    // Get the values from localStorage
    const state = localStorage.getItem('selectedState');
    const statenew = localStorage.getItem('selectedStateNew');

    if (state) {
        // Revert the state (convert dashes to spaces)
        const formattedState = state.replace(/-/g, ' ');

        // Capitalize the first letter of each word
        const capitalizedState = formattedState.replace(/\b\w/g, function(match) {
            return match.toUpperCase();
        });

        // Update selectedStateNew in localStorage to match the capitalized state
        if (statenew !== capitalizedState) {
            localStorage.setItem('selectedStateNew', capitalizedState);
        }
    }

    // Check if we are on a 'ce-requirements' page
    if (window.location.pathname.includes('/pages/ce-requirements/')) {
        // Check if localStorage contains the required values
        const discipline = localStorage.getItem("selectedDisciplineRequirement");
        const state = localStorage.getItem("selectedStateRequirement");

        if (discipline && state) {
            // Function to update product links
            const updateProductLinks = (links) => {
                links.forEach((link) => {
                    const href = link.getAttribute('href');
                    if (href && href.includes('/products/')) {
                        // Construct the new URL with the values from localStorage
                        const newHref = `/collections/${discipline.toLowerCase()}-continuing-education-${state.toLowerCase()}` + href;
                        link.setAttribute('href', newHref); // Update the href attribute
                    }
                });
            };

            // Select all product links on the main page
            const pageProductLinks = document.querySelectorAll('a[href^="/products/"]');
            updateProductLinks(pageProductLinks);

            // Select all product links in the quick drawer
            const quickDrawerProductLinks = document.querySelectorAll('.c_drawer_only a[href^="/products/"]');
            updateProductLinks(quickDrawerProductLinks);

            // Add a click listener to Quick View buttons to update URLs dynamically
            document.querySelectorAll('[data-action="quick-view"]').forEach((button) => {
                button.addEventListener('click', function() {
                    const productUrl = button.getAttribute('data-product-url');
                    if (productUrl && productUrl.includes('/products/')) {
                        const updatedUrl = `/collections/${discipline.toLowerCase()}-continuing-education-${state.toLowerCase()}` + productUrl;

                        // Update the button's data-product-url attribute
                        button.setAttribute('data-product-url', updatedUrl);

                        // Update the product link in the quick drawer dynamically
                        const quickViewProductLinks = document.querySelectorAll(`.c_drawer_only a[href="${productUrl}"]`);
                        quickViewProductLinks.forEach((link) => link.setAttribute('href', updatedUrl));
                    }
                });
            });

        } else {
            console.error("Discipline or State not found in localStorage.");
        }
    }

    // List of pages where the script should run
    const applicablePages = [
        "/pages/physical-therapy-continuing-education",
        "/pages/occupational-therapy-continuing-education",
        "/pages/unlimited-membership-for-occupational-therapy-ot",
        "/pages/speech-language-pathology-continuing-education",
        "/pages/athletic-training-continuing-education",
        "/pages/massage-therapy-continuing-education",
        "/pages/unlimited-ce-membership-physical-therapy",
        "/pages/physical-therapy-ce-approvals",
        "/pages/unlimited-ce-membership-occupational-therapy",
        "/pages/occupational-therapy-ce-approvals",
        "/pages/unlimited-ce-membership-speech-therapy",
        "/pages/speech-language-pathology-ce-approvals",
        "/pages/unlimited-ce-membership-athletic-training",
        "/pages/athletic-training-ce-approvals",
        "/pages/unlimited-ce-membership-massage-therapy",
        "/pages/massage-therapy-ce-approvals",
        "/pages/unlimited-ce-membership-speech-therapy-slp",
    ];

    // Discipline mapping for the specific page
    const disciplineMapping = {
        "/pages/physical-therapy-continuing-education": "pt",
        "/pages/occupational-therapy-continuing-education" : "ot",
        "/pages/unlimited-membership-for-occupational-therapy-ot" : "ot",
        "/pages/speech-language-pathology-continuing-education" : "slp",
        "/pages/athletic-training-continuing-education" : "atc-lat",
        "/pages/massage-therapy-continuing-education" : "mt-lmt",
        "/pages/unlimited-ce-membership-physical-therapy": "pt",
        "/pages/physical-therapy-ce-approvals": "pt",
        "/pages/unlimited-ce-membership-occupational-therapy": "ot",
        "/pages/occupational-therapy-ce-approvals": "ot",
        "/pages/unlimited-ce-membership-speech-therapy": "slp",
        "/pages/speech-language-pathology-ce-approvals": "slp",
        "/pages/unlimited-ce-membership-athletic-training": "atc-lat",
        "/pages/athletic-training-ce-approvals": "atc-lat",
        "/pages/unlimited-ce-membership-massage-therapy": "mt-lmt",
        "/pages/massage-therapy-ce-approvals": "mt-lmt",
        "/pages/unlimited-ce-membership-speech-therapy-slp": "slp",
    };

    // Retrieve the current URL
    const url = new URL(window.location.href);

    // Function to create and display the popup
    function showPopup() {
    // Check if the popup already exists
    if (document.querySelector(".state-selection-popup")) return;

    const popup = document.createElement("div");
    popup.classList.add("state-selection-popup");
    popup.style.position = "fixed";
    popup.style.top = "0";
    popup.style.left = "0";
    popup.style.width = "100%";
    popup.style.height = "100%";
    popup.style.background = "rgba(0, 0, 0, 0.8)";
    popup.style.zIndex = "9999";
    popup.style.display = "flex";
    popup.style.justifyContent = "center";
    popup.style.alignItems = "center";

    popup.innerHTML = `
      <div class="popup-content" style="background: #fff; padding: 30px 50px; border-radius: 16px; text-align: center;">
        <h2 class="rad_h4 text-center" style="color: #000; padding: 15px 0px 0px 0px;">We’re here to make your CE renewal effortless! Which state are you licensed in?</h2>
        <select class="state-selector disable_select rad_h6" style="width: 100%;">
            <option value="Alabama" selected>Alabama</option>
            <option value="Alaska">Alaska</option>
            <option value="Arizona">Arizona</option>
            <option value="Arkansas">Arkansas</option>
            <option value="California">California</option>
            <option value="Colorado">Colorado</option>
            <option value="Connecticut">Connecticut</option>
            <option value="Delaware">Delaware</option>
            <option value="District Of Columbia">District Of Columbia</option>
            <option value="Florida">Florida</option>
            <option value="Georgia">Georgia</option>
            <option value="Hawaii">Hawaii</option>
            <option value="Idaho">Idaho</option>
            <option value="Indiana">Indiana</option>
            <option value="Iowa">Iowa</option>
            <option value="Illinois">Illinois</option>
            <option value="Kansas">Kansas</option>
            <option value="Kentucky">Kentucky</option>
            <option value="Louisiana">Louisiana</option>
            <option value="Maine">Maine</option>
            <option value="Maryland">Maryland</option>
            <option value="Massachusetts">Massachusetts</option>
            <option value="Michigan">Michigan</option>
            <option value="Minnesota">Minnesota</option>
            <option value="Mississippi">Mississippi</option>
            <option value="Missouri">Missouri</option>
            <option value="Montana">Montana</option>
            <option value="Nebraska">Nebraska</option>
            <option value="Nevada">Nevada</option>
            <option value="New Hampshire">New Hampshire</option>
            <option value="New Jersey">New Jersey</option>
            <option value="New Mexico">New Mexico</option>
            <option value="New York">New York</option>
            <option value="North Carolina">North Carolina</option>
            <option value="North Dakota">North Dakota</option>
            <option value="Ohio">Ohio</option>
            <option value="Oklahoma">Oklahoma</option>
            <option value="Oregon">Oregon</option>
            <option value="Pennsylvania">Pennsylvania</option>
            <option value="Rhode Island">Rhode Island</option>
            <option value="South Carolina">South Carolina</option>
            <option value="South Dakota">South Dakota</option>
            <option value="Tennessee">Tennessee</option>
            <option value="Texas">Texas</option>
            <option value="Utah">Utah</option>
            <option value="Vermont">Vermont</option>
            <option value="Virginia">Virginia</option>
            <option value="Washington">Washington</option>
            <option value="West Virginia">West Virginia</option>
            <option value="Wisconsin">Wisconsin</option>
            <option value="Wyoming">Wyoming</option>
        </select>
        <span class="save-state" style="padding: .7em 40px; background: #f77d29; color: #fff; font-weight:600; border: none; cursor: pointer; border-radius: 2px;">Save</span>
      </div>
    `;

    document.body.appendChild(popup);

    // Function to handle save button click
    function saveStateHandler(event) {
        event.preventDefault();
        const selectedState = document.querySelector(".state-selector").value;

        if (selectedState) {
            localStorage.setItem("selectedStateNew", selectedState);
            localStorage.setItem("selectedState", selectedState.toLowerCase().replace(/\s+/g, '-'));
            
            document.body.removeChild(popup);
            updateStateAndDisciplineInURL(selectedState);
        } else {
            alert("Please select a state.");
        }
    }

    // Remove existing event listener if it exists, then add it again
    const saveButton = document.querySelector(".save-state");
    saveButton.removeEventListener("click", saveStateHandler);
    saveButton.addEventListener("click", saveStateHandler, { once: true });
}


    // Function to update the 'state' and 'discipline' parameters in the URL
    function updateStateAndDisciplineInURL(state) {
        let updated = false;

        // Check if the current page matches a discipline mapping
        Object.keys(disciplineMapping).forEach((page) => {
            if (url.pathname === page) {
                const discipline = disciplineMapping[page];
                // Check if state or discipline is already in the URL
                if (!url.searchParams.has("state") || !url.searchParams.has("discipline")) {
                    url.searchParams.set("state", state);
                    url.searchParams.set("discipline", discipline);
                    updated = true;
                }
            }
        });

        // If it's another page in the applicable list, update just the state
        if (!updated) {
            if (!url.searchParams.has("state")) {
                url.searchParams.set("state", state);
                updated = true;
            }
        }

        // Redirect to the updated URL only if necessary
        if (updated) {
            window.location.replace(url.toString());
        }
    }

    // Function to update product links
    function updateProductLinks() {

        function updateProductLinks(stateValue, collectionPrefix) {
            if (stateValue) {
                // Update links on the main page
                const productLinks = document.querySelectorAll('a[href^="/products/"]');
                productLinks.forEach((link) => {
                    const currentHref = link.getAttribute("href");
                    const updatedHref = currentHref.replace(
                        "/products/",
                        `/collections/${collectionPrefix}-${stateValue.toLowerCase().replace(/\s+/g, '-')}/products/`
                    );
                    link.setAttribute("href", updatedHref); // Update the href attribute
                });

                // Update links inside the quick view drawer
                const quickDrawerProductLinks = document.querySelectorAll('.c_drawer_only a[href^="/products/"]');
                if (quickDrawerProductLinks.length > 0) {
                    quickDrawerProductLinks.forEach((link) => {
                        const currentHref = link.getAttribute("href");
                        const updatedHref = currentHref.replace(
                            "/products/",
                            `/collections/${collectionPrefix}-${stateValue.toLowerCase().replace(/\s+/g, '-')}/products/`
                        );
                        link.setAttribute("href", updatedHref); // Update the href attribute
                    });
                } else {
                    // If quick view drawer links aren't available on initial load, check after some time
                    setInterval(() => {
                        const quickDrawerProductLinks = document.querySelectorAll('.c_drawer_only a[href^="/products/"]');
                        if (quickDrawerProductLinks.length > 0) {
                            quickDrawerProductLinks.forEach((link) => {
                                const currentHref = link.getAttribute("href");
                                const updatedHref = currentHref.replace(
                                    "/products/",
                                    `/collections/${collectionPrefix}-${stateValue.toLowerCase().replace(/\s+/g, '-')}/products/`
                                );
                                link.setAttribute("href", updatedHref); // Update the href attribute
                            });
                        }
                    }, 500); // Check every 500ms (you can adjust this interval)
                }
            } else {
                console.error("selectedState not found in localStorage.");
            }
        }

        const storedState = localStorage.getItem("selectedStateNew"); // Retrieve the selected state from localStorage

        if (storedState) {
            // Check if the current page is the target page for physical therapy
            if (window.location.href.includes("/pages/unlimited-ce-membership-physical-therapy") || window.location.href.includes("/pages/physical-therapy-ce-approvals")) {
                updateProductLinks(storedState, 'physical-therapy-continuing-education');
            }

            // Check if the current page is the target page for occupational therapy
            if (window.location.href.includes("/pages/unlimited-ce-membership-occupational-therapy") || window.location.href.includes("/pages/occupational-therapy-ce-approvals") || window.location.href.includes("/pages/unlimited-membership-for-occupational-therapy-ot") ) {
                updateProductLinks(storedState, 'occupational-therapy-continuing-education');
            }

            // Check if the current page is the target page for speech therapy
            if (window.location.href.includes("/pages/unlimited-ce-membership-speech-therapy") || window.location.href.includes("/pages/unlimited-ce-membership-speech-therapy-slp") || window.location.href.includes("/pages/speech-language-pathology-ce-approvals")) {
                updateProductLinks(storedState, 'speech-language-pathologist-continuing-education');
            }

            // Check if the current page is the target page for speech therapy
            if (window.location.href.includes("/pages/unlimited-ce-membership-athletic-training") || window.location.href.includes("/pages/athletic-training-ce-approvals")) {
                updateProductLinks(storedState, 'athletic-training-continuing-education');
            }

            // Check if the current page is the target page for speech therapy
            if (window.location.href.includes("/pages/unlimited-ce-membership-massage-therapy") || window.location.href.includes("/pages/massage-therapy-ce-approvals")) {
                updateProductLinks(storedState, 'massage-therapy-continuing-education');
            }

        }


    }

    // Check if the current page is in the applicable list
    if (applicablePages.includes(url.pathname)) {
        const storedState = localStorage.getItem("selectedStateNew");

        if (!storedState) {
            // Show the popup if no state is selected
            showPopup();
        } else {
            // Update the 'state' and 'discipline' parameters in the URL with the stored value
            updateStateAndDisciplineInURL(storedState);
            // Update product links
            updateProductLinks();
        }
    }

});


(function () {
    function syncStates(newValue) {
        if (newValue) {
            localStorage.setItem("selectedState", newValue);
            localStorage.setItem("selectedStateRequirement", newValue);
        }
    }

    //Sync values immediately on page load
    let latestState = localStorage.getItem("latestState");
    if (latestState) {
        syncStates(latestState);
    }

    //Listen for changes in localStorage across tabs
    window.addEventListener("storage", function (event) {
        if (event.key === "latestState") {
            syncStates(event.newValue);
        }
    });

    //Interval check to detect changes in the same tab
    setInterval(function () {
        let latestState = localStorage.getItem("latestState");
        let selectedState = localStorage.getItem("selectedState");

        if (latestState && latestState !== selectedState) {
            syncStates(latestState);
        }
    }, 1000);

    //Function to manually update latestState and sync
    window.updateLatestState = function (value) {
        localStorage.setItem("latestState", value);
        syncStates(value);
    };
})();


